// extracted by mini-css-extract-plugin
export default {"container":"StockShowcase_container__54X2d"};